// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__tper6 {
  padding: 2rem; }

.styles_header__5CtUq {
  margin-bottom: 2rem; }

.styles_invitationsCard__r\\+n0e {
  min-height: 60rem; }

.styles_tabContainer__Xoe0c {
  padding: 2rem;
  max-height: 55rem;
  overflow-y: auto; }
`, "",{"version":3,"sources":["webpack://./src/modules/admin/components/screens/AdminInvitationsScreen/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAa,EAAA;;AAGjB;EACI,mBAAmB,EAAA;;AAGvB;EACI,iBAAiB,EAAA;;AAGrB;EACI,aAAa;EACb,iBAAiB;EACjB,gBAAgB,EAAA","sourcesContent":[".container {\n    padding: 2rem;\n}\n\n.header {\n    margin-bottom: 2rem;\n}\n\n.invitationsCard {\n    min-height: 60rem;\n}\n\n.tabContainer {\n    padding: 2rem;\n    max-height: 55rem;\n    overflow-y: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__tper6`,
	"header": `styles_header__5CtUq`,
	"invitationsCard": `styles_invitationsCard__r+n0e`,
	"tabContainer": `styles_tabContainer__Xoe0c`
};
export default ___CSS_LOADER_EXPORT___;
